import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../CSS/Logout.css";
import { useAuth } from "../Services/AuthContext";

const Logout = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { user, loading: authLoading } = useAuth();
  
      const userName = user?.username || user?.userId || "User";

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("expires_in");
    localStorage.removeItem("token_type");

    navigate("/login", { replace: true });
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="topbar">
      <div className="profile-wrapper" ref={dropdownRef}>
        {/* Person Icon */}
        <div className="profile-icon" onClick={() => setOpen(!open)}>
          👤
        </div>

        {/* Dropdown */}
        {open && (
          <div className="profile-dropdown">
            {/* <h4>{userName}</h4> */}
            {userName}
            <button onClick={handleLogout}> 📤 Logout </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Logout;
 